import { IGridServerSideDatasource, toQuery, IServerSideGetRowsParams } from '@samc/centricity-core';
import { AjaxHelper, AjaxHelperException, IPaginatedList } from '@samc/common';
import { IReviewOrderSearch } from '@/Interfaces';

export class ReviewOrderDataSource implements IGridServerSideDatasource {
  public pageSize: number = 50;
  public cacheSize: number = 10;
  public adhocFilter: string = '';

  public _previousParams: IServerSideGetRowsParams | null = null;
  public _abortController: AbortController | null = null;

  public constructor(private _url: string, public id: number | null, public reviewTypeId: string | null, public organizationId: string | null, public productId: string | null, public packageId: string | null, public buyerId: string | null, public sellerId: string | null, public dataCallback: ((data: IReviewOrderSearch[]) => void) | null = null) { }

  public getRows(params: IServerSideGetRowsParams) {
    try {
      this._previousParams = params;
      const helper = new AjaxHelper(this._url, null, null, null);
      const query = toQuery(params);
      query.reviewTypeId = this.reviewTypeId;
      query.organizationId = this.organizationId;
      query.productId = this.productId;
      query.packageId = this.packageId;
      query.id = this.id;
      query.buyerId = this.buyerId;
      query.sellerId = this.sellerId;
      query.reviewTypeHasImportId = true;
      query.handler = 'SearchReviewOrders';
      if (this._abortController !== null) {
        this._abortController.abort('Review Order was called again');
        this._abortController = null;
      }

      setTimeout(async () => {
        this._abortController = new AbortController();
        const result = await helper.getData<IPaginatedList<IReviewOrderSearch>>('', query, { signal: this._abortController.signal });
        console.log({ result });
        params.success({ rowData: result.items, rowCount: result.fullCount });
        this._abortController = null;

        setTimeout(() => this.dataCallback !== null ? this.dataCallback(result.items) : 0);
      });
    } catch (err: any) {
      if (err instanceof AjaxHelperException) {
        params.success({ rowData: [], rowCount: 0 });
        return;
      }
      params.fail();
    }
  }
}
